import { Globe, FileText, Check, X } from "lucide-react";
import api, { zar } from "@/lib/api";
import { PageHeader, useFetch, Spinner } from "@/components/portal/ui";
import { StatusBadge } from "@/components/StatusBadge";
import { Progress } from "@/components/ui/progress";

const CBSTATUS = { Cleared: "Delivered", "Customs Clearance": "In Transit", "In Transit to Border": "At Risk" };

export default function CrossBorderOps() {
  const { data, loading } = useFetch(() => api.get("/crossborder").then((r) => r.data));
  if (loading) return <Spinner />;

  return (
    <div>
      <PageHeader title="Cross-Border Logistics" subtitle="Customs, documentation & compliance workflows" />
      <div className="space-y-5">
        {data.consignments.map((c) => (
          <div key={c.id} className="rounded-xl border border-border bg-card p-6" data-testid={`cb-${c.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <h3 className="font-heading font-bold font-mono flex items-center gap-2"><Globe size={18} className="text-primary" /> {c.tracking_number}</h3>
                <p className="text-sm text-muted-foreground mt-1">{c.corridor} · Border: {c.border}</p>
              </div>
              <StatusBadge status={CBSTATUS[c.status] || c.status} />
            </div>
            <div className="mt-4">
              <div className="flex justify-between text-xs text-muted-foreground mb-1"><span>Customs clearance</span><span>{c.clearance_pct}%</span></div>
              <Progress value={c.clearance_pct} className="h-2" />
            </div>
            <div className="mt-4 flex flex-wrap gap-4 text-sm">
              {[
                { l: "Commercial Invoice", v: c.commercial_invoice },
                { l: "Packing List", v: c.packing_list },
                { l: "Certificate of Origin", v: c.certificate_origin },
              ].map((d) => (
                <span key={d.l} className="flex items-center gap-1.5">
                  {d.v ? <Check size={15} className="text-emerald-600" /> : <X size={15} className="text-red-500" />}
                  <FileText size={13} className="text-muted-foreground" /> {d.l}
                </span>
              ))}
              <span className="ml-auto font-semibold">Duties: {zar(c.duties_zar)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
